module.exports = __webpack_public_path__ + "static/media/ln.4a1bf2ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ln.svg
// module id = 97
// module chunks = 0